module.exports = __webpack_public_path__ + "img/950-2a3777.png";